import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {PopupHelperService} from "../../../core/services/popup-helper.service";
import {EventManagerService} from '../../../core/services/event-manager.service';
import {QualityService} from "../../../core/services/quality.service";
import {customSetTimeout} from "../../../core/helpers/overrided-timers";
import {TranslateModule} from "@ngx-translate/core";
import {ModalComponent} from "../modal/modal.component";
import {FormsModule} from "@angular/forms";
import {PrimaryButtonComponent} from "../primary-button/primary-button.component";


@Component({
  selector: 'app-feed-back',
  templateUrl: './feed-back.component.html',
  standalone: true,
  imports: [
    TranslateModule,
    ModalComponent,
    FormsModule,
    PrimaryButtonComponent
  ],
  providers:  [PopupHelperService, QualityService],
  styleUrls: ['./feed-back.component.scss']
})
export class FeedBackComponent implements OnInit {
  @ViewChild('feedbackModal') feedbackModal: any

  public forId: any
  public forTable: any
  public myFeedBack: any
  public selectEvaluateValue: any
  public message: any
  private publisherId:any;
  private metadata: any;


  constructor(
              private popupHelperService: PopupHelperService,
              private eventManagerService:EventManagerService,
              private qualityService: QualityService,
              private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.eventManagerService.openFeedBackModalEmitter.subscribe((data: any)=>{
      if(data.forId && data.forTable){
        this.forId = data.forId
        this.publisherId = data.publisherId;
        this.forTable = data.forTable
        if (data.metadata){
          this.metadata = data.metadata
        }

        this.getMyFeedBack()
        this.feedbackModal.show();

      }else {
        this.popupHelperService.printError({text: 'invalid_params'})
      }

    })
  }


  onSubmit(){
    this.qualityService.addFeedBack({forId: this.forId, forTable: this.forTable, publisherId: this.publisherId, rate: this.selectEvaluateValue, message: this.message, metaData:this.metadata}).subscribe((data: any) => {
      if (!data.hasError){
        this.popupHelperService.printSuccess()
        customSetTimeout(()=>{
          this.feedbackModal.hide()
        }, 1500)
      }else {
        this.popupHelperService.printError({text: data.errorMessages[0].msg})
      }
    })
  }

  getMyFeedBack(){
    this.qualityService.getMyFeedBack(this.forId, this.forTable).subscribe((data: any) =>{
      if(!data.hasError){
        this.myFeedBack = data.data.myFeedBack
        if(this.myFeedBack){
          this.message = this.myFeedBack.message
          this.selectEvaluateValue = this.myFeedBack.rate
        }
      }
    })
  }

  selectEvaluate(evaluate: any){
    if (this.selectEvaluateValue !== evaluate) {
      this.selectEvaluateValue = evaluate;

    }else{
      this.selectEvaluateValue = null;
    }
    this.cdr.detectChanges()
  }

  doTextarea(value:any){
    this.message = value
  }

}
